<template>
  <div class="workflow">
    <one-floor @push='getSortVal' :userInfo="userInfo" />
    <two-floor :userInfo="userInfo" :type='type' :searchVal='searchVal' :isRefresh='isRefresh' @push="getFilterQuery" v-if="type" />
    <three-floor :templateInfo='templateInfo' :type="type" @refresh='refresh' />
  </div>
</template>
<script>
import OneFloor from './cards/oneFloor'
import TwoFloor from './cards/twoFloor'
import ThreeFloor from './cards/threeFloor'
export default {
  name: 'workflow',
  components: { OneFloor, TwoFloor, ThreeFloor },
  data() {
    return {
      type: 1,
      userInfo: {},
      templateInfo: {},
      searchVal: '',
      isRefresh: false
    }
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  },
  methods: {
    getSortVal(item, searchVal) {
      if (item) this.type = item.value;
      this.searchVal = searchVal;
    },
    getFilterQuery(item) {
      this.templateInfo = item
    },
    refresh() {
      this.isRefresh = !this.isRefresh
    }
  },
}
</script>
<style scoped lang="less">
.workflow {
  display: flex;
  background: #fff;
  height: 100%;
}
</style>